import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, countries, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing a view for filtering auto-exclusion users.
 * @extends JetView
 */
export default class FilterAutoexclusionUsersView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the filter form
        const left = {
            margin: 5,
            id: 'a1',
            autoheight: true,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // Label for ID input
                            labelPosition: 'top',
                            placeholder: _('Id'), // Placeholder for ID input
                            invalidMessage: _('ID is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'PlayerId',
                            type: 'number',
                            label: "<span class='icon-user'></span>" + _('ID Usuario'), // Label for Player ID input
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Conditional visibility based on permissions
                            ),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder for Player ID input
                            invalidMessage: _('ID Usuario is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'UserName',
                            label: "<span class='icon-mail'></span>" + _('Usuario (Correo electrónico)'), // Label for User Name input
                            labelPosition: 'top',
                            placeholder: _('Usuario (Correo electrónico)'), // Placeholder for User Name input
                            invalidMessage: _('Usuario is required'), // Validation message
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label for Activation Status
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'null', value: _('Todos') }, // Option for all
                                { id: 'A', value: _('Activado') }, // Option for activated
                                { id: 'I', value: _('Inactivado') }, // Option for deactivated
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'Categorie',
                            localId: 'categorie:combo',
                            label: "<span class='icon-category'></span>" + _('Categorías'), // Label for Categories
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [], // Options will be populated dynamically
                        },
                        {
                            view: 'richselect',
                            name: 'SubCategory',
                            localId: 'subCategorie:combo',
                            label: "<span class='icon-subcategory'></span>" + _('Sub Categoría'), // Label for Subcategory
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [], // Options will be populated dynamically
                        },
                    ],
                },
            ],
        };

        // Second left section of the filter form
        const left2 = {
            margin: 5,
            id: 'a1',
            autoheight: true,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'Game',
                            localId: 'game:combo',
                            label: "<span class='icon-games'></span>" + _('Juego'), // Label for Game selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [], // Options will be populated dynamically
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Default date range
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for Datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for Date input
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum date selectable
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'UserCreation',
                            label: "<span class='icon-folder-add'></span>" + _('Usuario Creación'), // Label for User Creation input
                            labelPosition: 'top',
                            placeholder: _('Usuario Creación'), // Placeholder for User Creation input
                            invalidMessage: _('Usuario Creación is required'), // Validation message
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'UserModified',
                            label: "<span class='icon-mode_edit'></span>" + _('Usuario Modificó'), // Label for User Modified input
                            labelPosition: 'top',
                            placeholder: _('Usuario Modificó'), // Placeholder for User Modified input
                            invalidMessage: _('Usuario Modificó is required'), // Validation message
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for Country selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for country options with flags
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Conditional visibility based on permissions
                                ),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for second Country selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for country options with flags
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Conditional visibility based on permissions
                                ),
                            css: 'prm-filterByCountry',
                            css: 'country-hide',
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout adjustment
                    ],
                },
            ],
        };

        // Upper section of the form
        const upper_section = {
            height: document.body.offsetWidth < 500 ? 370 : 0, // Conditional height based on screen size
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including the left section
                },
            ],
        };

        // Second upper section of the form
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 300 : 0, // Conditional height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Including the second left section
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Including the second upper section
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Button for clearing the form
                    autowidth: true,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue(
                            $$('myForm').getCleanValues().CountrySelect, // Reset country selection
                        );
                        $$('Datepicker').setValue(''); // Clear datepicker value
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Button for submitting the filter
                    hotkey: 'enter', // Shortcut key for submission
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection based on profile
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date field if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('autoexclusionUsers:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('b6').collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };

        // Accordion section for main filters
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for main filters
                            id: 'b6',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Including the upper section
                                    accordion_section, // Including the advanced filters section
                                    buttons, // Including the buttons section
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'myForm', // ID for the form
            type: 'clean',
            rows: [accordion_section2], // Including the main accordion section
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav2').hide(); // Hide element based on screen size
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if not applicable
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
